// extracted by mini-css-extract-plugin
export default {"container":"UpdateProduct_container__fX3xx","productForm":"UpdateProduct_productForm__8L31y","formContainer":"UpdateProduct_formContainer__++h8T"};